import type { Meta, StoryFn } from '@storybook/react';

import { Keyboard, Text } from '@pega/cosmos-react-core';
import type { KeyboardProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Badges/Keyboard',
  component: Keyboard
} as Meta;

export const KeyboardBadge: StoryFn<KeyboardProps> = (args: KeyboardProps) => {
  return (
    <Text variant='primary'>
      Generally <Keyboard keyName={args.keyName} /> is used as a modifier key
    </Text>
  );
};

KeyboardBadge.args = {
  keyName: 'Command'
};

KeyboardBadge.argTypes = {
  keyName: { control: { type: 'text' } }
};
